import { MapUnitConvertor } from '@datum-group/datum-map/lib/common';
import * as DatumMap from '@datum-map';
import { BufferZone } from './BufferZone';
import { DATUM_MAP_CONFIG } from './datumMapConfig';
import { INIT_MAP_DATA } from '@project/store/index';

export class MapStore {
  static MAX_ZOOM = 19;

  readonly mapProperties: DatumMap.MapProperties;
  readonly apiMap: DatumMap.APIMap;
  readonly layerCollection: DatumMap.LayerCollection;
  readonly projectCollection: DatumMap.ProjectCollection;
  readonly userActivityManager: DatumMap.UserActivityManager;
  readonly bufferZone: BufferZone;
  readonly mapUnitConvertor: MapUnitConvertor;

  constructor(
    srid: string,
    zoom: number,
    center: GeoJSON.Position,
    enableRotation: boolean,
    rotation: number,
  ) {
    this.mapProperties = new DatumMap.MapProperties(
      srid,
      center,
      zoom,
      enableRotation,
      rotation,
    );
    this.mapProperties.maxZoom = MapStore.MAX_ZOOM;

    this.layerCollection = new DatumMap.LayerCollection(
      this.mapProperties.map,
      DATUM_MAP_CONFIG.map.layer,
    );

    this.userActivityManager = new DatumMap.UserActivityManager(
      this.mapProperties.map,
      this.mapProperties,
    );

    this.projectCollection = new DatumMap.ProjectCollection(
      this.layerCollection,
    );
    this.apiMap = new DatumMap.APIMap(
      this.layerCollection,
      this.projectCollection,
    );
    this.mapUnitConvertor = new MapUnitConvertor(this.mapProperties.map);
    this.bufferZone = new BufferZone(
      this.mapProperties,
      this.layerCollection,
      this.mapUnitConvertor,
    );

    DatumMap.configuration.basePath = process.env.BACKEND_URL;
  }

  goToGeom = (geom: GeoJSON.Geometry) => {
    const converter = new DatumMap.GeoJSONConverter();

    const convertedGeom = converter.convertGeometry(
      'EPSG:4326',
      INIT_MAP_DATA.srid,
      geom,
    );

    if (convertedGeom.type === 'Point') {
      this.mapProperties.map.getView().animate({
        center: convertedGeom.coordinates,
        duration: 400,
        zoom: 18,
      });
    } else {
      const mapUtils = new DatumMap.MapUtils(this.mapProperties.map);

      this.mapProperties.extent = mapUtils.geomsToExtend([convertedGeom]);
    }
  };
}
